import { localize } from './L10n';

let studyplanId = null;

export const moduleTypes = {
  compulsory: {
    label: localize('moduleTypeCompulsory'),
    color: '#4B92A4',
  },
  core_elective: {
    label: localize('moduleTypeCoreElective'),
    color: '#B39048',
  },
  elective: {
    label: localize('moduleTypeElective'),
    color: '#D2C192',
  },
  thesis: {
    label: localize('moduleTypeThesis'),
    color: '#C60219',
  },
  practice_project: {
    label: localize('moduleTypePracticeProject'),
    color: '#E89AA3',
  },
  laboratory: {
    label: localize('moduleTypeLaboratory'),
    color: '#C60219',
  },
  research_methods: {
    label: localize('moduleTypeResearchMethods'),
    color: '#C60219',
  },
};

export const PLACEHOLDER_TYPE_NONE = 0;
export const PLACEHOLDER_TYPE_CORE_ELECTIVE = 1;
export const PLACEHOLDER_TYPE_ELECTIVE = 2;

export const getTypeFromModule = function (module) {
  let type = module.type;

  if (module.placeholderType === PLACEHOLDER_TYPE_CORE_ELECTIVE) {
    type = 'core_elective';
  }

  if (module.placeholderType === PLACEHOLDER_TYPE_ELECTIVE) {
    type = 'elective';
  }

  return [type, moduleTypes[type]];
};

export const setStudyplanId = (id) => {
  studyplanId = id;
};

export const getStorage = () => {
  const selectedModules = sessionStorage.getItem(`modules-${studyplanId}`);
  if (selectedModules) {
    return JSON.parse(selectedModules);
  }
  return [];
};
export const getSessionModules = (semester, emptyObject = true) => {
  const selectedModules = getStorage();
  if (selectedModules) {
    const { [semester]: semesterValue } = selectedModules;
    if (semesterValue) {
      return {
        selected: Object.values(semesterValue),
        dropzone: semesterValue,
      };
    }
  }
  if (emptyObject) {
    return {
      selected: [],
      dropzone: {},
    };
  }
};
export const setSessionModules = (state, semester) => {
  const storage = getStorage();

  sessionStorage.setItem(
    `modules-${studyplanId}`,
    JSON.stringify({
      ...(storage ? storage : {}),
      [semester]: state.dropzone,
    })
  );
};

export const setSession = (session) => {
  sessionStorage.setItem(`modules-${studyplanId}`, JSON.stringify(session));
};
